export default function encodeURIsearchParam(search: string) {
	return encodeURIComponent(search.trim());
}
